import React, { ChangeEvent, useCallback, useState } from 'react'
import { Box, Button, Grid, InputLabel, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { useDispatch, useSelector } from 'react-redux';
import { AppRootState } from '../../app/store';
import { NewTaskStateType } from '../NewTask/newTask-reducer';
import { addAttachmentToNewTaskTC, FileType } from './newTaskAttachments-reducer';
import { AddFirstAttachment } from '../common/AddFirstAttachment';
import { NewTaskAttachedItem } from './NewTaskAttachedItem';
import { ButtonAddAttachment } from '../common/ButtonAddAttachment';

type TaskDetailsPropsType = {
  projectName: string
  projectId: number
}

export const NewTaskAttachments = React.memo((props: TaskDetailsPropsType) => {
  const dispatch = useDispatch()

  const newTask = useSelector<AppRootState, NewTaskStateType>(state => state.newTask)
  let relations = useSelector<AppRootState, Array<FileType>>(state => state.newTaskAttachments.relations)

  const addFile = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    let file: any
    if (event.target.files) {
      file = event.target.files[0]
      console.log(file)
      let f = new Blob([file])
      let formData = new FormData()
      formData.append("formdata", file)
      console.log(f)
      dispatch(addAttachmentToNewTaskTC({ projectName: props.projectName, projectId: props.projectId, fileName: file.name, size: file.size, formData }))
    }
  }, [])

  if (relations.length === 0) {
    return <AddFirstAttachment addFile={addFile} />
  }

  return (
    <>
      <Typography>
        <b>Attachments</b>
      </Typography>
      <hr />
      <Grid container style={{ display: 'flex', margin: '10px', padding: '3px', fontSize: '14px' }} >
        <ButtonAddAttachment onClickButton={addFile} text='Add attachment'/>
      </Grid>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell >
              Name
            </TableCell>
            <TableCell >
              Size
              <span style={{ cursor: 'pointer', marginLeft: '5px' }}></span>
            </TableCell>
            <TableCell style={{ textAlign: 'center' }}>
              Date Attached
            </TableCell>
            <TableCell style={{ textAlign: 'center' }}>
              {/* xxx
              <span style={{ cursor: 'pointer', marginLeft: '5px' }}></span> */}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {relations.map((file) => <NewTaskAttachedItem file={file} projectId={props.projectId} />)}
        </TableBody>
      </Table>
    </>
  )
}
)
